'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ALIGNMENTS = exports.ALIGNMENTS = {
  left: {
    attachmentHoriz: 'left',
    attachmentVert: 'top',
    targetAttachmentHoriz: 'left',
    targetAttachmentVert: 'bottom'
  },
  middle: {
    attachmentHoriz: 'center',
    attachmentVert: 'top',
    targetAttachmentHoriz: 'center',
    targetAttachmentVert: 'bottom'
  },
  right: {
    attachmentHoriz: 'right',
    attachmentVert: 'top',
    targetAttachmentHoriz: 'right',
    targetAttachmentVert: 'bottom'
  }
};

var CONSTRAIN = exports.CONSTRAIN = {
  both: [{
    attachment: 'together none',
    pin: ['left', 'right'],
    to: 'window'
  }],
  none: [],
  horizontal: [{
    attachment: 'none',
    pin: ['left', 'right'],
    to: 'window'
  }],
  vertical: [{
    attachment: 'together none',
    to: 'window'
  }]
};

var MIN_MENU_WIDTH = exports.MIN_MENU_WIDTH = 144;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/constants/Tether.js
// module id = 298
// module chunks = 0